var _regeneratorRuntime = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/createClass.js");

/*
  Use cases for interacting with subnet peer nodes.
*/
var PeerUseCases = /*#__PURE__*/function () {
  "use strict";

  function PeerUseCases() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PeerUseCases);

    // Dependency Injection.
    this.adapters = localConfig.adapters;

    if (!this.adapters) {
      throw new Error('Must inject instance of adapters when instantiating Peer Use Cases library.');
    }

    this.controllers = localConfig.controllers;

    if (!this.controllers) {
      throw new Error('Must inject instance of controllers when instantiating Peer Use Cases library.');
    }
  } // Connect to a peer through available circuit relays. This ensures a short
  // path between peers, *before* broadcasting the OrbitDB message to them.
  // This method is primarily used by sendPrivateMessage() to allow for fast-
  // startup connection and communication with peers.


  _createClass(PeerUseCases, [{
    key: "connectToPeer",
    value: function () {
      var _connectToPeer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peerId, thisNode) {
        var relays, connectedPeers, connectedPeer, sortedRelays, i, thisRelay, multiaddr, connected;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                // console.log(`connectToPeer() called on ${peerId}`)
                relays = thisNode.relayData; // Get connected peers

                _context.next = 4;
                return this.adapters.ipfs.getPeers();

              case 4:
                connectedPeers = _context.sent;
                // Check if target peer is currently conected to the node.
                connectedPeer = connectedPeers.filter(function (peerObj) {
                  return peerObj.peer === peerId;
                }); // If this node is already connected to the peer, then return.
                // We do not need to do anything.

                if (!connectedPeer.length) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", true);

              case 8:
                // Sort the Circuit Relays by the average of the aboutLatency
                // array. Connect to peers through the Relays with the lowest latencies
                // first.
                sortedRelays = thisNode.useCases.relays.sortRelays(relays); // console.log(`sortedRelays: ${JSON.stringify(sortedRelays, null, 2)}`)
                // Loop through each known circuit relay and attempt to connect to the
                // peer through a relay.

                i = 0;

              case 10:
                if (!(i < sortedRelays.length)) {
                  _context.next = 22;
                  break;
                }

                thisRelay = sortedRelays[i]; // console.log(`thisRelay: ${JSON.stringify(thisRelay, null, 2)}`)
                // Generate a multiaddr for connecting to the peer through a circuit relay.

                multiaddr = "".concat(thisRelay.multiaddr, "/p2p-circuit/p2p/").concat(peerId); // console.log(`multiaddr: ${multiaddr}`)
                // Skip the relay if this node is not connected to it.

                if (!thisRelay.connected) {
                  _context.next = 19;
                  break;
                }

                _context.next = 16;
                return this.adapters.ipfs.connectToPeer(multiaddr);

              case 16:
                connected = _context.sent;

                if (!connected) {
                  _context.next = 19;
                  break;
                }

                return _context.abrupt("return", true);

              case 19:
                i++;
                _context.next = 10;
                break;

              case 22:
                return _context.abrupt("return", false);

              case 25:
                _context.prev = 25;
                _context.t0 = _context["catch"](0);
                console.error('Error in peer-use-cases.js/connectToPeer()');
                throw _context.t0;

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 25]]);
      }));

      function connectToPeer(_x, _x2) {
        return _connectToPeer.apply(this, arguments);
      }

      return connectToPeer;
    }() // Publish a string of text to another peers OrbitDB recieve database.
    // orbitdbId input is optional.

  }, {
    key: "sendPrivateMessage",
    value: function () {
      var _sendPrivateMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(peerId, str, thisNode) {
        var peerData, encryptedStr;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                // console.log('sendPrivateMessage() peerId: ', peerId)
                // console.log('\nsendPrivateMessage() str: ', str)
                // const peer = this.peers.state.peers[peerId]
                // console.log('thisNode.peerData: ', thisNode.peerData)
                peerData = thisNode.peerData.filter(function (x) {
                  return x.from === peerId;
                }); // console.log(
                //   `sendPrivateMessage peerData: ${JSON.stringify(peerData, null, 2)}`
                // )
                // Throw an error if the peer matching the peerId is not found.

                if (!(peerData.length === 0)) {
                  _context2.next = 4;
                  break;
                }

                throw new Error("Data for peer ".concat(peerId, " not found."));

              case 4:
                _context2.next = 6;
                return this.adapters.encryption.encryptMsg(peerData[0], str);

              case 6:
                encryptedStr = _context2.sent;
                _context2.next = 9;
                return this.adapters.pubsub.messaging.sendMsg(peerId, encryptedStr, thisNode);

              case 9:
                return _context2.abrupt("return", true);

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);
                console.error('Error in peer-use-cases.js/sendPrivateMessage(): ', _context2.t0);
                throw _context2.t0;

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 12]]);
      }));

      function sendPrivateMessage(_x3, _x4, _x5) {
        return _sendPrivateMessage.apply(this, arguments);
      }

      return sendPrivateMessage;
    }()
  }]);

  return PeerUseCases;
}();

module.exports = PeerUseCases;